import { render } from "./StudioMessageFormPopup.vue?vue&type=template&id=3475bbcc"
import script from "./StudioMessageFormPopup.vue?vue&type=script&lang=js"
export * from "./StudioMessageFormPopup.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__